import { Navigate, Route, Routes } from 'react-router-dom'
import { useAuth } from './auth/AuthProvider'
import AppLayout from './layout/AppLayout'
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import ReportsPage from './pages/ReportsPage'
import ReportDetailPage from './pages/ReportDetailPage'
import NewReportPage from './pages/NewReportPage'
import FillReportPage from './pages/FillReportPage'
import FreeReportPage from './pages/FreeReportPage'
import StartFreeReportPage from './pages/StartFreeReportPage'
import CompaniesPage from './pages/CompaniesPage'
import ImportPage from './pages/ImportPage'
import ActionsPage from './pages/ActionsPage'
import TemplatesPage from './pages/TemplatesPage'
import TemplateBuilderPage from './pages/TemplateBuilderPage'
import UsersPage from './pages/UsersPage'
import PlanningPage from './pages/PlanningPage'
import AnalyticsPage from './pages/AnalyticsPage'
import SearchPage from './pages/SearchPage'
import ArchivePage from './pages/ArchivePage'
import AuditLogPage from './pages/AuditLogPage'
import TenantsPage from './pages/TenantsPage'
import DeletedReportsPage from './pages/DeletedReportsPage'
import ReportFilesPage from './pages/ReportFilesPage'
import type { ReactNode } from 'react'

function RequireAuth({ children }: { children: ReactNode }) {
  const { user, initializing } = useAuth()
  if (initializing) return <div className="center">…</div>
  if (!user) return <Navigate to="/login" replace />
  return <>{children}</>
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth><AppLayout /></RequireAuth>}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/reports/new" element={<NewReportPage />} />
        <Route path="/reports/free" element={<StartFreeReportPage />} />
        <Route path="/reports/:id" element={<ReportDetailPage />} />
        <Route path="/reports/:id/fill" element={<FillReportPage />} />
        <Route path="/reports/:id/free" element={<FreeReportPage />} />
        <Route path="/companies" element={<CompaniesPage />} />
        <Route path="/imports" element={<ImportPage />} />
        <Route path="/actions" element={<ActionsPage />} />
        <Route path="/templates" element={<TemplatesPage />} />
        <Route path="/templates/:id" element={<TemplateBuilderPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/planning" element={<PlanningPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/archive" element={<ArchivePage />} />
        <Route path="/audit-log" element={<AuditLogPage />} />
        <Route path="/tenants" element={<TenantsPage />} />
        <Route path="/deleted-reports" element={<DeletedReportsPage />} />
        <Route path="/tenants/:tenantId/report-files" element={<ReportFilesPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
